import { Policy, SimplePolicy } from "@/policies";
import { userEntityOficial, userSuperAdmin } from "./role";
import { adminPolicy } from "./admin";
import {entityAdminPolicy} from "./admin-entity"
const policyNamespace = "entity";

interface UserFromEntityContext {
  userEntityId: unknown;
  entityId: unknown;
}

export function isUserFromEntityContext(
  obj: unknown
): obj is UserFromEntityContext {
  const tmp = obj as UserFromEntityContext;

  return tmp.entityId != undefined && tmp.userEntityId != undefined;
}

export const userFromEntity: Policy = {
  async can(context: unknown) {
    if (!isUserFromEntityContext(context)) {
      return false;
    }
    return context.entityId == context.userEntityId;
  },
};

const userFromEntityOrAdmin = new SimplePolicy(
  async (ctx: unknown) =>
    (await adminPolicy.can(ctx)) || (await userFromEntity.can(ctx))
);
const userFromEntityAndOficialOrAdmin = new SimplePolicy(
  async (ctx: unknown) =>
    (await adminPolicy.can(ctx)) ||
    ((await userFromEntity.can(ctx)) && (await userEntityOficial.can(ctx)))
);
const policyMap = new Map();

policyMap.set(`${policyNamespace}/view-any`, adminPolicy);
policyMap.set(`${policyNamespace}/view`, userFromEntityOrAdmin);
policyMap.set(`${policyNamespace}/create`, adminPolicy);
policyMap.set(`${policyNamespace}/edit`, adminPolicy);
policyMap.set(`${policyNamespace}/view-users`, userFromEntityAndOficialOrAdmin);
policyMap.set(`${policyNamespace}/edit-users`, userSuperAdmin);
policyMap.set(`${policyNamespace}/delete-users`, userSuperAdmin);
policyMap.set(`${policyNamespace}/create-users`, userSuperAdmin);
policyMap.set(`${policyNamespace}/department`, entityAdminPolicy);
export default policyMap;
